import React from 'react';
import { motion } from 'framer-motion';
export function EmpathySection() {
  return <section className="py-20 px-6 bg-[var(--bg-surface)] border-t border-[var(--bg-elevated)]" data-id="element-116">
      <div className="max-w-[680px] mx-auto" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-8" data-id="element-118">
          <h2 className="text-3xl md:text-4xl font-serif text-[var(--text-heading)] text-center" data-id="element-119">
            Sientes que tu fe se está apagando.
          </h2>

          <div className="space-y-6 text-lg text-[var(--text-primary)] leading-relaxed font-light" data-id="element-120">
            <p data-id="element-121">
              No porque dejaste de creer. Sino porque el dolor es tan ruidoso
              que ya no puedes escuchar a Dios.
            </p>
            <p data-id="element-122">Y la peor parte no es el sufrimiento en sí.</p>
            <div className="bg-[var(--bg-elevated)] p-6 rounded-lg border border-[var(--accent)]/20" data-id="element-123">
              <p className="text-xl font-serif text-[var(--accent)] text-center italic" data-id="element-124">
                La peor parte es que alguien te dice "ten fe"… <br data-id="element-125" />y tú no
                sabes cómo.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}